export default __webpack_public_path__ + "static/media/pix.8e5fdc10.svg";